import { ReactNode } from "react";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
export const openBottomSheet = () => {
  const element = document.getElementById("bottomsheet");
  if (element) {
    // Try modern scrollIntoView first
    try {
      element?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
    } catch (error) {
      // Fallback for Safari
      const elementPosition = element?.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - (window.innerHeight / 2 - 130);
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }

    // Additional fallback for Safari
    setTimeout(() => {
      if (element && Math.abs(element?.getBoundingClientRect().top) > 10) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }, 100);
  }
};
export const closeBottomSheet = () => {
  const element = document.getElementById("bottomsheet");
  element?.scrollIntoView({
    behavior: "smooth",
    block: "end",
    inline: "nearest"
  });
};
const BottomSheet = ({
  children,
  map,
  topSectionHeight = 0,
  onScroll,
  showMapButtonInBottomSheet
}: {
  children: ReactNode;
  map: ReactNode;
  onScroll?: () => void;
  topSectionHeight?: number | string;
  showMapButtonInBottomSheet: boolean;
}) => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const scrollBottomSheetContentToTop = () => {
    if (!showMapButtonInBottomSheet) return;
    const content = document.getElementById("bottomsheet-content");
    content?.scrollIntoView({
      block: "start",
      // scroll inner content to top
      behavior: "instant"
    });
  };
  return <div className='hideScrollBar relative flex h-[calc(100dvh_-_0px)] snap-y snap-proximity flex-row-reverse overflow-auto overscroll-none md:h-[calc(100dvh_-_80px)] lg:static lg:h-auto lg:overflow-visible' onScroll={onScroll} data-sentry-component="BottomSheet" data-sentry-source-file="index.tsx">
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div className={`fixed inline-block h-[calc(100%_-_0px)] w-full bg-[#E4E3DE] transition-all duration-300 ease-in md:sticky md:hidden md:w-0 xl:inline-block xl:w-[35.44%] ${topSectionHeight} lg:top-20`} onClick={isMobile ? closeBottomSheet : () => {}}>
        {map}
      </div>
      <div className='absolute bottom-[75px] z-[2] h-0 w-full overflow-visible transition-all duration-300 ease-in-out md:relative lg:relative lg:bottom-[30px] lg:h-auto xl:w-[64.56%]'>
        <div className='h-fit w-full rounded-t-3xl bg-offWhite'>
          <div id='bottomsheet' className='scroll-mt-[calc(50vh_-_300px)]' />
          <button className='disable_click sticky top-20 z-10 w-full rounded-t-3xl bg-offWhite py-3' onClick={() => {
          if (!showMapButtonInBottomSheet) {
            openBottomSheet();
          }
        }} onMouseDown={scrollBottomSheetContentToTop} onTouchStart={scrollBottomSheetContentToTop} aria-label='bottomsheet handle'>
            <div className='mx-auto h-[3px] w-16 rounded-full bg-[#8d8989]'></div>
          </button>
          <div id='bottomsheet-content' className='scroll-mt-[88px]'>
            {children}
          </div>
        </div>
      </div>
    </div>;
};
export default BottomSheet;